import Story from './Story'

export default Story